import React, { FC } from 'react';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FormItem, useFiltersLabel, FiltersNameEnum, FilterDrawerType } from '@blocs.filter';
import { FiltersCategoryNameEnum } from '../../shared/types';
import { NewTalent } from '../../FilterDrawerCollection';

interface Props {
  type: FilterDrawerType;
}

const NewTalentCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { isCategoryMatchedSearch } = useDrawerSearchFilterNameOrCategory(FiltersCategoryNameEnum.newTalent);

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <NewTalent name={FiltersNameEnum.isNewTalent} label={filtersLabelOfAudience[FiltersNameEnum.isNewTalent]} />
      </FormItem>
    )
  );
};

export default NewTalentCategory;
